import React, { Component } from "react";
import PropTypes from "prop-types";
import { extractNameFromPageTitle } from "components/utility/analytics/util";
import ImageCopyLinkIcon from "components/utility/images/ImageCopyLinkIcon";

class ContentPageShareLink extends Component {
	handleCopy = (e) => {
		var textField = document.createElement("textarea");
		textField.setAttribute("class", "content-page-share-lite-temp-textarea");
		textField.setAttribute("readonly", "");
		textField.setAttribute("tabindex", "0");
		textField.innerText = this.props.shareUrl;
		e.target.appendChild(textField);

		textField.select();
		textField.setSelectionRange(0, 99999);
		document.execCommand("copy");
		textField.parentNode.removeChild(textField);

		let closestModal = document.getElementsByClassName("content-page-share-modal-overlay");
		var node = document.createElement("div");
		node.classList.add("content-page-share-link-confirmed");
		var textnode = document.createTextNode(this.props.copyConfirm);
		node.appendChild(textnode);
		closestModal[0].appendChild(node);

		setTimeout(function () {
			if (document.getElementsByClassName("content-page-share-link-confirmed")[0]) {
				document.getElementsByClassName("content-page-share-link-confirmed")[0].remove();
			}
		}, 2000);
	};
	render() {
		const { shareUrl, shareLabel, copyLabel, shareLabelMobile, className, analytics } = this.props;
		const mobileCopyLabel =
			copyLabel + (shareLabelMobile ? ` ${shareLabelMobile}` : ` ${shareLabel}`);
		return (
			<div className={`content-page-share-link ${className ? className : ""}`}>
				<div className="content-page-share-link-label">{shareLabel}</div>
				<div className="content-page-share-link-field">
					<div className="content-page-share-link-url" data-qa="content-page-share-link-url">
						{shareUrl}
					</div>
					<button
						className="content-page-share-link-copy-button"
						aria-label={copyLabel}
						onClick={this.handleCopy}
						data-a="true"
						data-a-lbl={document.title}
						data-a-cat="Share"
						data-a-act={copyLabel}
						data-a-evt="Share"
						data-a-comp={analytics.comp}
						data-a-icon="copy"
						data-a-name={extractNameFromPageTitle(analytics.title)}
					>
						{copyLabel}
					</button>
				</div>
				<button
					className="content-page-share-link-field-mobile"
					aria-label={mobileCopyLabel}
					onClick={this.handleCopy}
					data-a="true"
					data-a-lbl={document.title}
					data-a-cat="Share"
					data-a-act={copyLabel}
					data-a-evt="Share"
					data-a-comp={analytics.comp}
					data-a-icon="copy"
					data-a-name={extractNameFromPageTitle(analytics.title)}
				>
					<ImageCopyLinkIcon />
					{<div className="content-page-share-link-label-mobile">{mobileCopyLabel}</div>}
				</button>
			</div>
		);
	}
	static propTypes = {
		shareUrl: PropTypes.string,
		shareLabel: PropTypes.string,
		copyLabel: PropTypes.string,
		shareLabelMobile: PropTypes.string,
		className: PropTypes.string,
		copyConfirm: PropTypes.string
	};
}

export default ContentPageShareLink;
